import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";;
import { SnackBarService } from '../../service/snack.bar.service';
import { GetPurchaserUserDetailsGQL } from '../../../../generated/graphql';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';


export interface DialogData {
    userId: string;
}

@Component({
    selector: 'purchaser-user-dialog',
    templateUrl: 'purchaser-user-dialog.html',
})
export class PurchaserUserDialog implements OnInit {
    public psConfig: PerfectScrollbarConfigInterface = {};

    title: string;
    result: any;
    salesDetail: any

    constructor(
        public dialogRef: MatDialogRef<PurchaserUserDialog>,
        private getPurchaserUserDetailsGQL: GetPurchaserUserDetailsGQL,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private snackBarSvc: SnackBarService,) {
        this.title = 'Purchaser Info '
    }

    ngOnInit() {
        this.getInfo();
    }

    getInfo() {
        this.getPurchaserUserDetailsGQL
            .fetch({ userId: this.data.userId })
            .subscribe((record) => {
                let data = record.data.getPurchaserUserDetails
                this.result = data;
                this.salesDetail = data?.unitDetailOutput
            })
    }

    callTo(number) {
        if (!number) return;
        window.location.href = `tel:${number}`;
    }

    mailTo(email) {
        if (!email) return;
        window.location.href = `mailto:${email}`;
    }
}